import { AxiosError } from 'axios';

const getHeaderFromAxiosErrorResponse = (response: AxiosError, headerName: string): string => {
    const headers = response?.response?.headers;
    let header = '';
    if (headers) {
        header = headers[headerName] || '';
    }
    return header;
};

export const getXRequestId = (response: AxiosError): string => {
    return getHeaderFromAxiosErrorResponse(response, 'x-request-id');
};

export default {};
